// Not re-exported from src/helpers/index.ts on purpose: this file lives inside
// src/helpers/, so going through the barrel would be self-referential.
import { configVars } from 'src/helpers/configVars';

// Applicant-experience hosts both document upload portal pages. Fraud-platform
// no longer serves either one, so there is no localhost origin to fall back to.
const getApplicantExperienceUrl = () => configVars.document_portal;

const generateLink = (
  baseUrl: string,
  prefixUrl: string,
  propertyId: string,
  companyId: string
) => {
  if (companyId && propertyId && companyId !== '' && propertyId !== '') {
    return `${baseUrl}${prefixUrl}${companyId}/${propertyId}`;
  } else throw new Error('Company and/or property id is missing');
};

export const getPublicLink = (propertyId: string, companyId: string) => {
  return generateLink(getApplicantExperienceUrl(), '/application/apply/', propertyId, companyId);
};

export const getLeasingTeamLink = (propertyId: string, companyId: string) => {
  const loginUrl = generateLink(getApplicantExperienceUrl(), '/login/', propertyId, companyId);
  return `${loginUrl}?onBehalfOf=true`;
};
